export const mapPropertyToFirestore = (property: string) => {
  switch (property) {
    case 'postcode':
      return 'address.postcode';
    default:
      return property;
  }
};
